import React, { useState, useEffect } from "react";
import { Loader } from "semantic-ui-react";
import { size, map } from "lodash";
import { Role } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { RoleItem } from "../RoleItem";

const roleController = new Role();

export function ListRole(props) {
  const { reload, onReload } = props;
  const [roles, setRoles] = useState(null);
  const { accessToken } = useAuth();

  useEffect(() => {
    (async () => {
      try {
        setRoles(null);
        const response = await roleController.getRoles();
        setRoles(response);
      } catch (error) {
        console.error(error);
      }
    })();
  }, [reload, accessToken]);

  if (!roles) return <Loader active inline="centered" />;
  if (size(roles) === 0) return "No existen tipos de usuario registrados";

  return map(roles, (role) => (
    <RoleItem key={role.id} role={role} onReload={onReload} />
  ));
}
